import { render, staticRenderFns } from "./PriceLabelingDropdown.vue?vue&type=template&id=754e8626&"
import script from "./PriceLabelingDropdown.vue?vue&type=script&lang=js&"
export * from "./PriceLabelingDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports